import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerDeleteProductGroup(id: string, name: string) {
	logGoogleTagManagerEvent({
		event: 'cogvio.groupDelete',
		groupDelete: {
			id,
			name,
		},
	});
}
